import React from 'react';

import PropTypes from 'prop-types';

import TrackerCard from './trackerCard';

const AssetTracker = ({ hardwareList, tracker }) => {
  const {
    assetTrackerRateplanTotal,
    additionalServicesTotal,
    addonsTotal,
    vehiclesTotal
  } = tracker;
  const props = {
    title: 'Asset Tracker',
    hardwareList,
    rateplanTotal: assetTrackerRateplanTotal,
    ...(additionalServicesTotal && { additionalServicesTotal }),
    addonsTotal,
    vehiclesTotal
  };
  return <TrackerCard {...props} />;
};

AssetTracker.propTypes = {
  hardwareList: PropTypes.objectOf(PropTypes.any).isRequired,
  tracker: PropTypes.shape({
    fleetTrackerRateplanTotal: PropTypes.number,
    assetTrackerRateplanTotal: PropTypes.number,
    additionalServicesTotal: PropTypes.number,
    addonsTotal: PropTypes.number,
    vehiclesTotal: PropTypes.number
  }).isRequired
};

export default AssetTracker;
